import { useEffect } from 'react'
import { isNativeTextEntryTarget } from '@renderer/utils/is-interactive-focused'

/**
 * ⌘↵ saves while `enabled`. Capture phase: the body editor's HardBreak
 * extension also binds Mod-Enter, and it would insert a newline before a
 * bubble-phase listener ever heard the key. The `isNativeTextEntryTarget`
 * guard keeps ⌘↵ typed in a native text field (the feedback popover) with that
 * field rather than saving the draft.
 */
export function useCmdEnterSave(enabled: boolean, onSave: () => void | Promise<unknown>): void {
  useEffect(() => {
    if (!enabled) {
      return
    }
    const onKeyDown = (e: globalThis.KeyboardEvent) => {
      if (isNativeTextEntryTarget(e.target)) {
        return
      }
      if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
        e.preventDefault()
        e.stopPropagation()
        void onSave()
      }
    }
    window.addEventListener('keydown', onKeyDown, true)
    return () => window.removeEventListener('keydown', onKeyDown, true)
  }, [enabled, onSave])
}
